<template>
  <div
    class="lv-flex-box"
    :style="{
      'flex-direction': flexDirection,
      'justify-content': justifyContent,
      'align-items': alignItems,
      width: width,
    }"
    :class="{ 'no-wrap': noWrap, 'gap-8': gap8, 'gap-4': gap4 }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    flexDirection: {
      type: String,
      default: 'row',
    },
    justifyContent: {
      type: String,
      default: 'start',
    },
    alignItems: {
      type: String,
      default: 'center',
    },
    noWrap: {
      type: Boolean,
    },
    width: {
      type: String,
    },
    gap8: {
      type: Boolean,
      default: true,
    },
    gap4: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
